var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_336_20785)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M20.8302 14.4897H14.4902V20.8297L20.8302 14.4897Z",
    fill: "#91BC68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24023 7.23975H14.4902",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24023 10.8701H14.4902",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24023 14.4897H10.8702",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1204 20.8299H1.81039C1.31039 20.8299 0.900391 20.4199 0.900391 19.9199V1.8099C0.900391 1.3099 1.31039 0.899902 1.81039 0.899902H19.9204C20.4204 0.899902 20.8304 1.3099 20.8304 1.8099V14.1099C20.8304 14.3499 20.7404 14.5799 20.5704 14.7399L14.7504 20.5599C14.5804 20.7299 14.3504 20.8299 14.1204 20.8299Z",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7502 14.4897H14.4902V20.7497",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_336_20785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.73,
    height: 21.73,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRools);
export default __webpack_public_path__ + "static/media/rools.4d7e273f988f27bf60d72d0dda8c5688.svg";
export { ForwardRef as ReactComponent };